import { asDate } from "@@/shared/date-time/as-date";
import type {
    TimeRange} from "@@/shared/date-time/time-range";
import {
    timeRangeByDurationFactory,
    timeRangeFactory,
} from "@@/shared/date-time/time-range";
import type {
    DurationInMinutes} from "@@/shared/date-time/time-spans";
import {
    inMilliseconds,
} from "@@/shared/date-time/time-spans";
import { addMinutes } from "date-fns";
import type { ResourceSchedule } from "./resource-schedule";
import type { ResourceScheduleInterval } from "./resource-schedule-interval";

const calculateResourceSchedule = (
    schedule: ResourceSchedule,
    timeRange: TimeRange
) => {
    return schedule.intervals.map(i => apply(i, timeRange));
};
const apply = (interval: ResourceScheduleInterval, timeRange: TimeRange) => {
    const start = calculateStart(interval.fromSessionStart, timeRange);
    return calculateTimeRange(start, interval.duration, timeRange);
};

const calculateStart = (
    intervalStart: DurationInMinutes | "START" | "END",
    timeRange: TimeRange
) => {
    if (intervalStart === "START") return asDate(timeRange.start);
    if (intervalStart === "END") return asDate(timeRange.end);
    return addMinutes(asDate(timeRange.start), intervalStart);
};

const calculateTimeRange = (
    intervalStart: Date,
    intervalDuration: DurationInMinutes | "END",
    timeRange: TimeRange
) => {
    if (intervalDuration === "END")
        return timeRangeFactory(intervalStart, asDate(timeRange.end));

    return timeRangeByDurationFactory(
        intervalStart,
        inMilliseconds({ minutes: intervalDuration })
    );
};

export { calculateResourceSchedule };
